<template>

    <div class="sidebar">
      <div class="row">
        <div class="bg-light sticky-top bg-dark">
          <div
            class="align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100"
          >
            <a
              href="/home"
              class="d-flex align-items-center justify-content-center py-4"
            >
              <!-- Logo -->
              <img :src="`/img/svg/Logo_Grupo_Mass.svg`" alt="Logo de la empresa" class="img-fluid">
            </a>

            <div class="dropdown">
              <!--EMPRESAS-->
              <div class="dropdown mt-3">
                <a
                  href="#"
                  class="d-flex align-items-center text-white text-decoration-none dropdown-toggle menu-button"
                  id="dropdownArmas"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                <i class="bi bi-cursor-fill"></i
                  ><span class="d-none d-sm-inline mx-2">Empresas</span>
                </a>
                <ul
                  class="dropdown-menu dropdown-menu-dark text-small shadow"
                  aria-labelledby="dropdownArmas"
                >
                  <li>
                    <router-link
                      :to="{ name: 'ListCompanies' }"
                      class="nav-link"
                      ><a class="dropdown-item" href="#"
                        ><i class="bi bi-share-fill mx-2"></i>Ver Links</a
                      ></router-link
                    >
                  </li>

                  <li>
                      <router-link
                        :to="{ name: 'CreateCompany' }"
                        class="nav-link"
                        ><a class="dropdown-item" href="#"
                          ><i class="bi bi-building-fill-add mx-2"></i>Crear Empresa</a
                        ></router-link
                      >
                  </li>

                </ul>
              </div>
              <!-- FORMULARIOS PUBLICOS-->
              <div class="dropdown mt-3">
                <a
                  href="#"
                  class="d-flex align-items-center text-white text-decoration-none dropdown-toggle menu-button"
                  id="dropdownArmas"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i class="bi bi-cursor-fill"></i
                  ><span class="d-none d-sm-inline mx-2">Formularios</span>
                </a>
                <ul
                  class="dropdown-menu dropdown-menu-dark text-small shadow"
                  aria-labelledby="dropdownArmas"
                >
                  <li>
                    <router-link
                      :to="{ name: 'ListFormsPublic' }"
                      class="nav-link"
                      ><a class="dropdown-item" href="#"
                        ><i class="bi bi-file-earmark-richtext mx-2"></i>Lista</a
                      ></router-link
                    >
                  </li>

                </ul>
              </div>

              <!-- USUARIOS -->
              <!-- <div v-if="mostrarComponentAdmin" > -->
              <div>
                <div class="dropdown mt-3">
                  <a
                    href="#"
                    class="d-flex align-items-center text-white text-decoration-none dropdown-toggle menu-button"
                    id="dropdownUsuario"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="bi bi-person"></i
                    ><span class="d-none d-sm-inline mx-2">Usuarios</span>
                  </a>
                  <ul
                    class="dropdown-menu dropdown-menu-dark text-small shadow"
                    aria-labelledby="dropdownUsuario"
                  >
                    <li>
                      <router-link
                        :to="{ name: 'ListUsuario' }"
                        class="nav-link"
                        ><a class="dropdown-item" href="#"
                          ><i class="bi bi-people-fill mx-2"></i>Lista Usuarios</a
                        ></router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'CreateUsuario' }"
                        class="nav-link"
                        ><a class="dropdown-item" href="#"
                          ><i class="bi bi-person-plus-fill mx-2"></i>Crear Usuario</a
                        ></router-link
                      >
                    </li>
                   
                  </ul>
                </div>
              </div>
              <!-- Menú desplegable "Sistema" -->
              <div class="dropdown mt-3">
                <a
                  href="#"
                  class="d-flex align-items-center text-white text-decoration-none dropdown-toggle menu-button"
                  id="dropdownSistema"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i class="bi bi-power"></i
                  ><span class="d-none d-sm-inline mx-2">Sistema</span>
                </a>
                <ul
                  class="dropdown-menu dropdown-menu-dark text-small shadow"
                  aria-labelledby="dropdownSistema"
                >
                  <li>
                    <a class="dropdown-item btn" @click="logout">
                      <i class="bi bi-power"></i>
                      <span class="d-none d-sm-inline mx-2">Cerrar sesión</span>
                    </a>
                  </li>
                </ul>
              </div>
             
              <div class="dropdown mt-3">
                <a href="#" class="d-flex align-items-center text-white text-decoration-none  menu-button" 
                id="" 
                data-bs-toggle="" 
                aria-expanded="">
                  <span class="d-none d-sm-inline mx-2">{{ username }}</span>
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
  import { ref, onMounted } from 'vue'
  import router from '../router'
  import AuthService from "../apis/User"

  export default {
    name: "SidebarView",
    setup() {
      const isDarkMode = ref(false);
      const showSubMenu = ref(false);
      const userIsAuthenticated = ref(false);
      const showSubMenuArmas = ref(false);
      const mostrarComponentAdmin = ref(false);
      const codUdLocalStorage = localStorage.getItem('codUd');

  
      const toggleDarkMode = () => {
        isDarkMode.value = !isDarkMode.value;
      };

      const toggleSubMenu = () => {
        showSubMenuArmas.value = !showSubMenuArmas.value;
      };

      const logout = async () => {
        try {
          await AuthService.postLogout();
          localStorage.removeItem("token");
          userIsAuthenticated.value = false;
          router.push({ name: "Login" });
        } catch (error) {
          console.error("Error al cerrar sesión:", error);
        }
      };

      const checkAuthentication = () => {
        const token = localStorage.getItem("token");
        userIsAuthenticated.value = !!token; 
      };

      onMounted(() => {
        checkAuthentication;
        // MUESTRA SOLO PARA ADMIN
        /* if (codUdLocalStorage == 24) {
            mostrarComponentAdmin.value = true;
          }  */
      });

      return {
        isDarkMode,
        showSubMenu,
        userIsAuthenticated,
        codUdLocalStorage,
        showSubMenuArmas,
        username: localStorage.getItem('username') || 'Usuario',
        logout,
        checkAuthentication,
        toggleDarkMode,
        toggleSubMenu,
        // urlBase,
        //mostrarComponentAdmin,
      };
    },

    beforeRouteEnter(to, from, next) {
      const token = localStorage.getItem("token");
      if (!token) {
        next({ name: "Login" });
      } else {
        next();
      }
    },
  };
</script>